import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  doubtsListRequest: ['payload'],
  doubtsListSuccess: ['stages', 'isLoading'],
  doubtsListFail: ['isLoading', 'error'],

  doubtsAnswersRequest: ['payload'],
  doubtsAnswersSuccess: ['stages', 'isLoading'],
  doubtsAnswersFail: ['isLoading', 'error'], 
});

const INITIAL_STATE = {
  duvidas:[],
  hasMore: true,
  page: 1
};


const doubtsListRequest = state => ({ ...state, isLoading: true });
const doubtsListSuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoading: false
});     
const doubtsListFail = (state, error) => ({ ...state, isLoading: false, error });


const doubtsAnswersRequest = state => ({ ...state, isLoading: true });
const doubtsAnswersSuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoading: false
});     
const doubtsAnswersFail = (state, error) => ({ ...state, isLoading: false, error });



export default createReducer(INITIAL_STATE, {
  [Types.DOUBTS_LIST_REQUEST]: doubtsListRequest,
  [Types.DOUBTS_LIST_SUCCESS]: doubtsListSuccess,
  [Types.DOUBTS_LIST_FAIL]: doubtsListFail,

  [Types.DOUBTS_ANSWERS_REQUEST]: doubtsAnswersRequest,
  [Types.DOUBTS_ANSWERS_SUCCESS]: doubtsAnswersSuccess,
  [Types.DOUBTS_ANSWERS_FAIL]:    doubtsAnswersFail,


});
